export default {"src":"/_next/static/media/CA.85256ba5.svg","height":20,"width":29};